import React from "react";
import "./Placement.css";
import classroomImage from "../../Images/Banner/program1.13de0bd60005a1a90fd2.jpg";
import { Container } from "react-bootstrap";

const Sec2 = () => {
  return (
    <section
      className="container py-5 mb-5 justify-content-between"
      style={{ opacity: 1, transform: "none" }}
    >
     <div className="container-xxl">
        <div className="row align-items-center">
          {/* Left Column - Text */}
          <div className="col-md-6">
            <div className="p-4">
              <h2 className="fw-bold text-dark">
                Training and Placement Cell at ISBM University
              </h2>
              <div className="underlinetwo"></div>
              <p>
                Training & Placement Department has an important role to furnish
                and groom the future of students. We act as an interface among
                students and the employment community. We empower students with
                lifelong career decision-making skills. This department
                continuously strives to support students in pursuing their
                career goals by acquiring employment-seeking skills and
                ultimately to attain desired employment. This is accomplished
                through building a strong bridge between Industry and Academia.
              </p>

              <p>
                Training and Placement coordinators are the official arbitrators
                for campus placement in ISBM University. Its enthusiastic team
                strives for effectively striking a match between recruiter
                expectations and student aspirations. Training and Placement
                cell is a support system to help the students realize their full
                potential and accomplish their career aspirations.
              </p>

              <p>
                Training and Placement Office, student & Faculty Co-ordinators
                handle various crucial tasks in the office. The Placement team
                consists of the Placement Managers, trainers, student
                representatives & Faculty Placement Coordinators of respective
                branches who primarily coordinate Training & Placements
                activities on two paths:
              </p>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="col-md-6 d-flex justify-content-center position-relative">
            <div className="image-box">
              <div className="image-bg"></div>
              <img
                src={classroomImage}
                style={{ objectFit: "cover", height: "450px", width: "100%" }}
                alt="JNU Campus"
                className="img-fluid rounded position-relative"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sec2;
